import { cadastreStyle, mapStyle, orthoStyle, planStyle, maptilerStyle } from '@/utils/mapStyles';
import { parseDate, dateFormat } from '@/utils/dateHelpers';

export const styles = [
  {
    label: 'Plan IGN',
    styleName: 'plan',
    styleUrl: planStyle,
  },
  {
    label: 'Scan 25',
    styleName: 'map',
    styleUrl: mapStyle,
  },
  {
    label: 'Ortho Photo',
    styleName: 'ortho',
    styleUrl: orthoStyle,
  },
  {
    label: 'Cadastre',
    styleName: 'cadastre',
    styleUrl: cadastreStyle,
  },
  {
    label: 'Plan OSM',
    styleName: 'maptiler',
    styleUrl: maptilerStyle,
  },
];

export const defaultStyle = styles[0];

export const translateActivity = activities =>
  activities.map(activity => {
    switch (activity) {
      case 'cycling':
        return 'Pédaler';
      case 'running':
        return 'Courir';
      case 'skiing':
        return 'Skier';
      case 'walking':
        return 'Marcher';
      case '':
        return 'Toutes activités';
      default:
        return activity;
    }
  }).join(', ');

export const c = {
  tracks: 'T',
  users: 'U',
};

export const cUnits = {
  T: 'passages',
  U: 'pratiquants',
};

export const colors = {
  cycling: 'rgba(0, 158, 9, 1)',
  skiing: 'rgba(0, 22, 255, 1)',
  walking: 'rgba(235, 0, 255, 1)',
  running: 'rgba(255, 29, 0, 1)',
};

export const periodCategories = {
  hour: 'heure',
  weekday: 'jour',
  month: 'mois',
  season: 'saison',
};

export const goToItiPolyText = {
  iti: 'Voir dans itinéraire défini',
  poly: 'Voir dans emprise géographique',
};

export const itiPolyColors = {
  iti: {
    main: '#320c52',
    hover: '#c29ae3',
  },
  poly: {
    main: '#0e9e5d',
    hover: '#7ff0bd',
  },
};

export const dataDefaultScale = [1, 40];
export const dataDiffScale = [-15, 15];

export const dataMinMaxColors = ['#2159bb', '#e33164'];
export const dataDiffMinMaxColors = ['#2159bb', '#e33164'];

export const suricateOptions = {
  type: [
    { value: '', name: 'Tous' },
    { value: 'Balisage / Signalétique', name: 'Balisage / Signalétique' },
    { value: 'Conflits d\'usage', name: 'Conflits d\'usage' },
    { value: 'Environnement', name: 'Environnement' },
    { value: 'Incident / Sécurité', name: 'Incident / Sécurité' },
  ],
  ampleur: [
    { value: '', name: 'Tous' },
    { value: 'possible', name: 'possible' },
    { value: 'difficile', name: 'difficile' },
    { value: 'impossible', name: 'impossible' },
  ],
  statut: [
    { value: '', name: 'Tous' },
    { value: 'Déposé', name: 'Déposé' },
    { value: 'Classé', name: 'Classé' },
    { value: 'En cours de traitement', name: 'En cours de traitement' },
    { value: 'Résolu', name: 'Résolu' },
  ],
  activite: [
    { value: '', name: 'Tous' },
    { value: 'Aviron', name: 'Aviron' },
    { value: 'Baignade, natation en eau libre', name: 'Baignade, natation en eau libre' },
    { value: 'Canoë-kayak', name: 'Canoë-kayak' },
    { value: 'Canyonisme', name: 'Canyonisme' },
    { value: 'Char à voile', name: 'Char à voile' },
    { value: 'Course d\'orientation', name: 'Course d\'orientation' },
    { value: 'Cyclisme sur pistes cyclables, véloroutes', name: 'Cyclisme sur pistes cyclables, véloroutes' },
    { value: 'Équitation', name: 'Équitation' },
    { value: 'Escalade', name: 'Escalade' },
    { value: 'Kite surf, snowkite (Glisses aérotractées)', name: 'Kite surf, snowkite (Glisses aérotractées)' },
    { value: 'Motocyclisme', name: 'Motocyclisme' },
    { value: 'Nage en eaux vives', name: 'Nage en eaux vives' },
    { value: 'Plongée', name: 'Plongée' },
    { value: 'Pêche', name: 'Pêche' },
    { value: 'Raid multisport', name: 'Raid multisport' },
    { value: 'Randonnée pédestre', name: 'Randonnée pédestre' },
    { value: 'Raquette à neige', name: 'Raquette à neige' },
    { value: 'Roller', name: 'Roller' },
    { value: 'Ski alpin', name: 'Ski alpin' },
    { value: 'Ski nordique', name: 'Ski nordique' },
    { value: 'Sports de traîneau', name: 'Sports de traîneau' },
    { value: 'Spéléologie', name: 'Spéléologie' },
    { value: 'Tir à l\'arc', name: 'Tir à l\'arc' },
    { value: 'Trail', name: 'Trail' },
    { value: 'Via ferrata / via corda', name: 'Via ferrata / via corda' },
    { value: 'Vol libre (parapente, deltaplane)', name: 'Vol libre (parapente, deltaplane)' },
    { value: 'VTT', name: 'VTT' },
  ],
};
export const minZoomFluxDisplay = 10;
export const maxZoomFluxDisplay = 14;

export const defaultZoom = 13.23;
export const defaultCenter = [4.37978, 44.40176];
export const maxZoom = 18;
export const minZoomForDynamicScale = 13;

export const breaks = {
  min: { color: '#2159bb', value: 0, label: '15 min - 30 min' },
  mid: { color: '#cc9c33', value: 30, label: '30 min - 1h' },
  max: { color: '#e33164', value: 60, label: '1 h - 2h30' },
};

export const breaksStopsCountMax = 30;

export const themesUrl = `${process.env.VUE_APP_BACKEND_API_URL}/exploration/poly_tree`;
export const searchUrl = `${process.env.VUE_APP_BACKEND_API_URL}/exploration/poly_search`;
export const itiThemesUrl = `${process.env.VUE_APP_BACKEND_API_URL}/exploration/iti_tree`;
export const itiSearchUrl = `${process.env.VUE_APP_BACKEND_API_URL}/exploration/iti_search`;
const configUrl = `${process.env.VUE_APP_BACKEND_API_URL}/exploration/config`;
export const collectionBaseUrl = `${process.env.VUE_APP_BACKEND_API_URL}/exploration/poly`;

export const defaultPolygonId = '';

export const f7minPercentage = 0.75;

export const primevueFrenchLocale = {
  startsWith: 'Commence par',
  contains: 'Contient',
  notContains: 'Ne contient pas',
  endsWith: 'Finit par',
  equals: 'Egale',
  notEquals: 'N\'est pas égal',
  noFilter: 'Pas de filtres',
  lt: 'Moins que',
  lte: 'Moins que ou égal à',
  gt: 'Plus que ou égal à',
  gte: 'Plus que',
  dateIs: 'La date est',
  dateIsNot: 'La date n\'est pas',
  dateBefore: 'La date est avant',
  dateAfter: 'La date est après',
  clear: 'Effacer',
  apply: 'Appliquer',
  matchAll: 'Toutes correspondances',
  matchAny: 'N\'importe quelle correspondances',
  addRule: 'Ajouter une règle',
  removeRule: 'Supprimer la règle',
  accept: 'Oui',
  reject: 'Non',
  choose: 'Choisir',
  upload: 'Charger',
  cancel: 'Annuler',
  dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
  dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
  dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
  monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
  monthNamesShort: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aout', 'Sept', 'Oct', 'Nov', 'Dec'],
  today: 'Aujourd\'hui',
  weekHeader: 'Sem',
  firstDayOfWeek: 0,
  dateFormat: 'mm/dd/yy',
  weak: 'Semaine',
  medium: 'Moyen',
  strong: 'Fort',
  passwordPrompt: 'Entrer votre mot de passe',
  emptyFilterMessage: 'Pas de résultats',
  emptyMessage: 'Pas d\'options disponibles',
};

const defaultTracksMin = 5;
const defaultUsersMin = 3;
// Fallback if failing to reach server
const defaultConfig = {
  'prnsn.min_tracks': '1000',
  'prnsn.min_tracks_zoom_9': '250',
  'prnsn.min_tracks_zoom_10': '100',
  'prnsn.min_tracks_zoom_11': '50',
  'prnsn.min_tracks_zoom_12': '30',
  'prnsn.min_tracks_zoom_13': '10',
  'prnsn.min_tracks_zoom_14': '5',
  'prnsn.min_users': '1000',
  'prnsn.min_users_zoom_9': '150',
  'prnsn.min_users_zoom_10': '60',
  'prnsn.min_users_zoom_11': '30',
  'prnsn.min_users_zoom_12': '18',
  'prnsn.min_users_zoom_13': '6',
  'prnsn.min_users_zoom_14': '3',
  prnsn_config_latest_date: '2042-12-11T14:40:02+00:00',
  prnsn_config_earliest_date: '2041-12-03T10:31:38+00:00',
};

/**
 * Create Map for min zoom configration from settings received from the backend
 *
 * @param {array of object} config
 * @returns {Map}
 */
export const getMinsConfigMap = (config = defaultConfig) => new Map(
  Object.entries(config)
    .filter(([key]) => key.includes('min')) // keep mins configuration only
    .map(([key, value]) => [key, parseInt(value, 10)]),
);

export const getDateConfigMap = (config = defaultConfig) => new Map(
  Object.entries(config)
    .filter(([key]) => key.includes('date')) // keep date configuration only
    .map(([key, value]) => [key, parseDate(value, dateFormat)]),
);

// Load configuration from the server, if provided will replace the default one
export async function getAppConfig () {
  const response = await fetch(configUrl);

  // Apply default mins configuration
  let config = defaultConfig;

  if (response.ok) {
    config = await response.json();
  } else {
    console.log(`An error has occured fetching the app configuration: ${response.status}`);
  }

  return config;
}

export const getUnitsDescription = (minsConfigMap = defaultConfig) => [
  { code: 'tracks', name: 'Passages', min: minsConfigMap.get('prnsn.min_tracks_zoom_14') || defaultTracksMin },
  { code: 'users', name: 'Pratiquants', min: minsConfigMap.get('prnsn.min_users_zoom_14') || defaultUsersMin },
];

// Départs / Arrivées - Nombre de départ / Nombre d'arrivée / Nombre de départs + arrivées
// To do : renseigner la configuration serveur à utiliser si elle est ajoutée à l'avenir
export const getEndsUnitsDescription = () => [
  { code: 'start', name: 'Départs', popupLabel: 'départs', min: 3 },
  { code: 'stop', name: 'Arrivées', popupLabel: 'arrivées', min: 3 },
  { code: 'both', name: 'Les deux', popupLabel: 'départs + arrivées', min: 3 },
];

export const getValueFromUnitsDescription = (unitDescription = [], i = 0, key) => {
  if (!unitDescription || !i || !key || unitDescription.length <= i) {
    return null;
  }
  const item = unitDescription[i];
  return item?.[key];
};

export const getDefaultValues = (
  fluxUnitsDescription, endsUnitsDescription, stopsUnitsDescription,
) => {
  const endsUnitsLastItemIndex = endsUnitsDescription.length > 0
  && endsUnitsDescription.length - 1;
  const endsMin = getValueFromUnitsDescription(endsUnitsDescription, endsUnitsLastItemIndex, 'min') || 3;
  const endsDefaultUnit = getValueFromUnitsDescription(endsUnitsDescription, endsUnitsLastItemIndex, 'code') || 'both';

  const stopsUnitsLastItemIndex = stopsUnitsDescription.length > 0
    && stopsUnitsDescription.length - 1;
  const stopsMin = getValueFromUnitsDescription(stopsUnitsDescription, stopsUnitsLastItemIndex, 'min') || 15;
  const stopsDefaultUnit = getValueFromUnitsDescription(stopsUnitsDescription, stopsUnitsLastItemIndex, 'code') || '';

  const fluxDefaultUnit = getValueFromUnitsDescription(fluxUnitsDescription, 'code') || 'tracks';

  const fluxTracksDefaultMin = fluxUnitsDescription.find(item => item?.code === 'tracks')?.min || defaultTracksMin;
  const fluxUsersDefaultMin = fluxUnitsDescription.find(item => item?.code === 'users')?.min || defaultUsersMin;

  return {
    fluxTracksDefaultMin,
    fluxUsersDefaultMin,
    fluxDefaultUnit,
    endsMin,
    endsDefaultUnit,
    stopsMin,
    stopsDefaultUnit,
  };
};

// Pauses - Durée moyenne
export const getStopsUnitsDescription = () => [{ code: '', min: 15, max: 180 }];

/**
 * Create array of min zoom configuration to display min values
 * of tracks and users for each zoom level
 * Note : we filter it by minZoomFluxDisplay (front settings for max zoom level)
 *
 * @param {Map} minsConfigMap
 * @returns {array of object}
 */
export const getZoomUnitMin = (minsConfigMap = defaultConfig) => {
  const allConfig = [
    { bounds: [-Infinity, 9], tracks: null, users: null },
    { bounds: [9, 10], tracks: minsConfigMap.get('prnsn.min_tracks_zoom_9'), users: minsConfigMap.get('prnsn.min_users_zoom_9') },
    { bounds: [10, 11], tracks: minsConfigMap.get('prnsn.min_tracks_zoom_10'), users: minsConfigMap.get('prnsn.min_users_zoom_10') },
    { bounds: [11, 12], tracks: minsConfigMap.get('prnsn.min_tracks_zoom_11'), users: minsConfigMap.get('prnsn.min_users_zoom_11') },
    { bounds: [12, 13], tracks: minsConfigMap.get('prnsn.min_tracks_zoom_12'), users: minsConfigMap.get('prnsn.min_users_zoom_12') },
    { bounds: [13, 14], tracks: minsConfigMap.get('prnsn.min_tracks_zoom_13'), users: minsConfigMap.get('prnsn.min_users_zoom_13') },
    { bounds: [14, Infinity], tracks: minsConfigMap.get('prnsn.min_tracks_zoom_14'), users: minsConfigMap.get('prnsn.min_users_zoom_14') },
  ];

  // Filter by minZoomFluxDisplay
  const filteredConfig = allConfig.filter(({ bounds }) => bounds[0] >= minZoomFluxDisplay);
  // if necessary, add the first level of the config
  // (out of this zoom level, data is not show, tracks & users should be null)
  if (filteredConfig[0]?.bounds[0] !== -Infinity) {
    const firstLevelConfig = { bounds: [-Infinity, minZoomFluxDisplay], tracks: null, users: null };
    filteredConfig.unshift(firstLevelConfig);
  }

  return filteredConfig;
};

/**
 * List unique zoom value thresholds between zoom unit minimum bounds configuration
 *
 * @param {array of object} zoomUnitMinConfig
 * @returns {array of number}
 */
export const getZoomBoundsList = (
  zoomUnitMinConfig = [{ bounds: [-Infinity, 11], tracks: null, users: null }],
) => [...new Set(zoomUnitMinConfig.map(({ bounds }) => bounds).flat())];

/**
 * Detect if new zoom value is crossing a threshold
 * from bounds configuration
 *
 * @param {float} newZoom
 * @param {float} oldZoom
 */
export const zoomCrossBoundsThreshold = (
  boundsList = [11, 12, 13, 14], newZoom, oldZoom,
) => boundsList
  .map(bound => (newZoom >= bound && oldZoom < bound) || (newZoom <= bound && oldZoom > bound))
  .some(item => item);

export const getMinAtZoomLevel = (
  minsConfig = [{ bounds: [-Infinity, 11], tracks: null, users: null }],
  currentZoomLevel,
) => minsConfig.find(({ bounds }) => bounds[0] <= currentZoomLevel && bounds[1] > currentZoomLevel);

export const buildMapMessage = zoomUnitMin => zoomUnitMin.map(({ bounds, tracks, users }) => ({
  bounds,
  message: tracks && users
    ? `Seuil minimal d'affichage\n- Passages ≥ ${tracks}\n- Pratiquants ≥ ${users}`
    : 'Zoomez pour voir les données',
}));

export const serverUnreachableMessage = 'Il semble que le serveur ne soit pas en mesure d\'envoyer de données. Veuillez réessayez dans quelques minutes ou contactez un administrateur si le problème persiste.';

export const buildUnitWarningMsg = threshold =>
  threshold && `Attention, le seuil minimum sélectionné n'est pas effectif car inférieur à celui conditionné par le niveau de zoom courant (seuil de ${threshold})`;

export const unavailableDateRangeMessage = 'Attention la date de début et/ou fin n\'est pas applicable à la plage d\'années sélectionnée';
export const requestErrorMessage = 'Le serveur a rencontré une erreur pendant le traitement de cette requête, contactez un administrateur si le problème persiste.';

export const comparisonViewsSwitch = {
  title: 'Type de visualisation',
  options: ['1 carte', '2 cartes'],
};

export const tileAllPeriodSuffix = '';
export const forceBothRangeDateExplanation = 'Les deux dates doivent être sélectionnées';

export const rangePeriodTexts = {
  mainTitle: 'Plages temporelles et périodes',
  dateRangeTitle: 'Plage temporelle et/ou période',
  exclusionRangeTitle: 'Plage temporelle à exclure',
  exclusionRangeDescription: 'Appliquer une exclusion pour la comparaison',
  diff: {
    title: 'Comparer les flux de fréquentation entre A et B',
    firstRange: 'A : Plage temporelle et/ou période',
    secondRange: 'B : Plage temporelle et/ou période',
  },
  double: {
    title: 'Comparer les flux de fréquentation entre la carte de gauche et la carte de droite',
    firstRange: 'Gauche : Plage temporelle et/ou période',
    secondRange: 'Droite : Plage temporelle et/ou période',
  },
};

export const colorLegendTitles = {
  tracks: 'Nombre de passages',
  users: 'Pratiquants uniques en moyenne par période',
};

export const notAuthorizedMessage = {
  default: "Vous n'êtes pas autorisé à accéder à cette page.",
  cgu: "Pour accéder à la plateforme Outdoorvision, vous devez accepter les conditions générales d'utilisation. Merci",
};

export const notAuthorizedButton = {
  default: 'Retourner sur le site OutdoorVision',
  cgu: 'Retourner sur la page de connexion',
};
